<template>
    <section class="vh-auto">
        <div class="container py-5 h-100">
            <div class="row d-flex justify-content-center align-items-center h-100">
                <div class="col col-lg-12 mb-4 mb-lg-0">
                    <div v-if="this.badge != null" class="card mb-3 shadow p-3 mb-5 bg-body rounded"
                        style="border-radius: .5rem;">
                        <div class="row g-0">
                            <div class="col-md-4 gradient-custom text-center text-white"
                                style="border-top-left-radius: .5rem; border-bottom-left-radius: .5rem;">
                                <img v-bind:src="require('../../assets/avatar-small.png')" alt="Avatar"
                                    class="img-fluid my-5" style="width: 80px;" />
                                <h5>{{ badge.lastName }}</h5>
                                <p>{{ badge.firstName }}</p>
                                <i class="far fa-edit mb-5"></i>
                            </div>
                            <div class="col-md-8">
                                <div class="card-body p-4">
                                    <h6>Badge</h6>
                                    <hr class="mt-0 mb-4">
                                    <div class="row pt-1">
                                        <div class="col-6 mb-3">
                                            <h6>Référence</h6>
                                            <p class="text-muted">{{ badge.ref }}</p>
                                        </div>
                                        <div class="col-6 mb-3">
                                            <h6>Identifiant</h6>
                                            <p class="text-muted">{{ badge.number }}</p>
                                        </div>
                                    </div>
                                    <h6>Information</h6>
                                    <hr class="mt-0 mb-4">
                                    <div class="row pt-1">
                                        <div class="col-6 mb-3">
                                            <h6>Profil</h6>
                                            <p class="text-muted">
                                                <span v-if="badge.profile.name != null">
                                                    {{ badge.profile.name }}
                                                </span>
                                                <span v-else class="text-black-50 fst-italic">
                                                    Aucun profil
                                                </span>
                                            </p>
                                        </div>
                                        <div class="col-6 mb-3">
                                            <h6>Statut</h6>
                                            <p class="text-muted">
                                                <InfoDisplay :icon="badge.disabled ? 'cross' : 'check'"
                                                    :color="badge.disabled ? 'red' : 'green'"
                                                    :toolTip="badge.disabled ? 'Désactivé' : 'Actif'" :size="'xl'" />
                                            </p>
                                        </div>
                                    </div>
                                    <div class="d-flex justify-content-start">
                                        <a href="#!"><i class="fab fa-facebook-f fa-lg me-3"></i></a>
                                        <a href="#!"><i class="fab fa-twitter fa-lg me-3"></i></a>
                                        <a href="#!"><i class="fab fa-instagram fa-lg"></i></a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import InfoDisplay from '@/components/display/InfoDisplay.vue'

export default {
    props: ['badge'],
    components: {
        InfoDisplay
    },
}
</script>

<style>
.gradient-custom {
    /* fallback for old browsers */
    background: #f6d365;

    /* Chrome 10-25, Safari 5.1-6 */
    background: -webkit-linear-gradient(to right bottom, #e4ae6d, #f06322);

    /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
    background: linear-gradient(to right bottom, #e4ae6d, #f06322)
}
</style>